module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            Login\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "field-wrapper username"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n                    Username\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.email),
      expression: "loginData.email"
    }],
    ref: "username",
    attrs: {
      "type": "text",
      "placeholder": "Please type in your username ...",
      "name": "username",
      "id": "username"
    },
    domProps: {
      "value": (_vm.loginData.email)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper password"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n                    Password\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Please type in your password ...",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.loginData.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "remember-me"
  }, [_c('label', {
    staticClass: "checkcontainer",
    attrs: {
      "for": "remember"
    }
  }, [_vm._v("\n                    Remember me\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.rememberMe),
      expression: "loginData.rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "name": "remember",
      "id": "remember"
    },
    domProps: {
      "checked": Array.isArray(_vm.loginData.rememberMe) ? _vm._i(_vm.loginData.rememberMe, null) > -1 : (_vm.loginData.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.loginData.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.loginData, "rememberMe", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.loginData, "rememberMe", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.loginData, "rememberMe", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("\n                    Log in\n                ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'ForgotPassword'
      }
    }
  }, [_vm._v("\n                    Forgot password?\n                ")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fb09950"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/login.vue
// module id = 281
// module chunks = 1